/**
 * Pure payment-amount helpers — no state, no DI.
 *
 * Consolidates the `Math.round(x)` pattern that was repeated in every
 * DashboardComponent.validate*Amount() method.
 */
export function roundCurrency(value: number): number {
  return Math.round(value);
}
